import {
    ViewEncapsulation,
    Component,
    HostBinding,
    OnInit,
    ElementRef,
    inject,
    input,
    computed,
    Signal,
    ChangeDetectionStrategy,
} from '@angular/core';
import { SizeRange } from '@bazis/shared/models/base.types';

const sharedStylesheet = new CSSStyleSheet();
sharedStylesheet.replaceSync(
    `:host { --width: initial; --height: initial; --border-radius: inherit; --width-huge: var(--width); --height-huge: var(--height); --border-radius-huge: var(--border-radius); --width-regular: var(--width); --height-regular: var(--height); --border-radius-regular: var(--border-radius); --width-compact: var(--width); --height-compact: var(--height); --border-radius-compact: var(--border-radius); --width-mini: var(--width); --height-mini: var(--height); --border-radius-mini: var(--border-radius); --background: initial; --color: inherit; --color-hover: var(--color); --font-size: inherit; --font-weight: inherit; --icon-size: inherit; display: flex; align-items: center; justify-content: center; border-radius: var(--border-radius); width: var(--width); height: var(--height); background: var(--background); color: var(--color); font-size: var(--font-size); font-weight: var(--font-weight); user-select: none; } :host img { width: 100%; height: 100%; border-radius: var(--border-radius); object-fit: cover; } :host bazis-icon { font-size: var(--icon-size); } :host:hover { color: var(--color-hover); } :host(.bazis-avatar_huge) { width: var(--width-huge); height: var(--height-huge); border-radius: var(--border-radius-huge); } :host(.bazis-avatar_huge) img { border-radius: var(--border-radius-huge); } :host(.bazis-avatar_regular) { width: var(--width-regular); height: var(--height-regular); border-radius: var(--border-radius-regular); } :host(.bazis-avatar_regular) img { border-radius: var(--border-radius-regular); } :host(.bazis-avatar_compact) { width: var(--width-compact); height: var(--height-compact); border-radius: var(--border-radius-compact); } :host(.bazis-avatar_compact) img { border-radius: var(--border-radius-compact); } :host(.bazis-avatar_mini) { width: var(--width-mini); height: var(--height-mini); border-radius: var(--border-radius-mini); } :host(.bazis-avatar_mini) img { border-radius: var(--border-radius-mini); } :host(.bazis-avatar.bazis-color) { background: var(--bazis-color-base); color: var(--bazis-color-contrast); }`,
);

@Component({
    selector: 'bazis-avatar',
    templateUrl: './avatar.component.html',
    // styleUrls: ['avatar.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class AvatarElement implements OnInit {
    public el = inject(ElementRef);

    readonly src = input<string>();

    readonly alt = input<string>();

    readonly lastName = input<string>('');

    readonly firstName = input<string>('');

    readonly emptyIcon = input<string>('user');

    readonly size = input<SizeRange>(SizeRange.large);
    //                        mini  compact    regular    large        huge    giant
    // readonly size = input<'xs' | 'small' | 'medium' | 'default' | 'large'>('default');

    readonly active = input<boolean>();

    readonly disabled = input<boolean>();

    readonly text = input<string>();

    @HostBinding('role') get roleElement() {
        return 'img';
    }

    readonly fio: Signal<string> = computed(() => {
        if (this.firstName()?.length && this.lastName()?.length) {
            return `${this.lastName()[0]}${this.firstName()[0]}`;
        }
        return '';
    });

    @HostBinding('class') get avatarClass() {
        return {
            'bazis-avatar': true,
            [`bazis-avatar_${this.size()}`]: !!this.size(),
            'bazis-avatar--active': this.active(),
            'bazis-avatar--disabled': this.disabled(),
            'bazis-avatar_photo': this.src(),
        };
    }

    ngOnInit(): void {
        // this.disabled = this.disabled !== undefined && this.disabled !== false;
        // this.active = this.active !== undefined && this.active !== false;

        const host = this.el.nativeElement;
        if (host && host.shadowRoot) {
            const shadowRoot = host.shadowRoot;
            const styles = shadowRoot.querySelectorAll('style');
            styles.forEach((style) => style.remove());
            shadowRoot.adoptedStyleSheets = [sharedStylesheet];
        }
    }
}
